export default __webpack_public_path__ + "static/media/image5.611cf619.jpg";